/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type ESMCategory = (typeof ESMCategory)[keyof typeof ESMCategory];

export const ESMCategory = {
    General: 0,
    FireProtectionSystemsEquipment: 1,
    EmergencyLightingExitSigns: 2,
    AirHandlingWaterSystems: 3,
    Other: 4,
} as const;
